/*********************************************
Translation example:
  button: {
    search: 'Search'
  },
==>
  button: {
    search: 'Search'
  },
*********************************************/
export default {
  payingText: 'Paying ...',

  general: {
    change: 'Change',
    save: 'Save',
    cancel: 'Cancel',
    or: 'Or',
    privacyPolicy: 'Privacy',
    privacyPolicyLink: 'https://www.clickdishes.com/privacy-policy',
    termsOfUse: 'Terms',
    termsOfUseLink: 'https://www.clickdishes.com/term',
    restaurants: 'Restaurants',
    restaurantsLink: 'https://www.clickdishes.com/restaurant',
    facebookLink: 'https://www.facebook.com/ClickDishes/',
    twitterLink: 'https://twitter.com/clickdishes',
    instagramLink: 'https://www.instagram.com/clickdishes/',
    agreeButtonText: 'Yes, I agree',
    serverError: 'Sorry, server error...',
    signin: 'Sign In',
    confirm: {
      soloOrder: 'Create your own solo order?'
    },
    success: {
      orderSent: 'Order is sent successfully!'
    },
    error: {
      permissionNotAllowed:
        'Sorry, you do not have permsision to access this resource.',
      nameOnCard: 'Name on card is required!',
      convertToSoloOrder: 'Sorry, unable to convert to solo order.'
    },

    filterText: 'Filter',
    specialRequest: 'Special Request',
    orderNumber: 'Order #',
    okText: 'Ok',
    email: 'Email',
    ptsText: 'pts',
    address: '{streetNumber} {streetName}, {city}'
  },
  page: {
    copyright: 'Copyright',
    company: 'Joyaa',
    rightsReserved: 'All rights reserved.'
  },
  header: {
    signinText: 'Sign In',
    signupText: 'Sign Up',
    signoutText: 'Sign Out',
    accountMenu: {
      updateAccount: 'Update Account',
      orderHistory: 'Order History',
      rewards: 'Rewards',
      inviteFriends: 'Refer Friends',
      friends: 'Friends',
      paymentMethods: 'Payment Methods',
      accountText: 'Account',
      help: 'Get Help',
      helpUrl: 'https://www.clickdishes.com/faq',
      signout: {
        confirmText: 'Do you want to delete the current order?'
      }
    },

    changeLocation: {
      tooltip: 'Change your location'
    },

    search: {
      tooltip: 'Search restaurant by name',
      closeButtonText: 'Close',
      placeholder: 'Search restaurant by name'
    }
  },
  spinner: {
    text: 'Loading ...'
  },

  showMore: {
    buttonText: 'Show More ...'
  },

  confirm: {
    yesButtonText: 'Yes',
    noButtonText: 'No',
    cancelButtonText: 'Cancel',
    titleText: 'Confirm'
  },

  rating: {
    level45Text: '4.5 & up',
    level40Text: '4.0 & up',
    level35Text: '3.5 & up',
    level30Text: '3.0 & up'
  },
  signin: {
    title: 'Sign In',
    spinner: {
      text: 'Sign In ...'
    },
    email: {
      placeholder: 'Email',
      validation: 'Email is required'
    },
    password: {
      placeholder: 'Password',
      validation: 'Password is required'
    },

    signinText: 'Sign In',

    or: 'Or',
    forgetPassword: 'Forgot Password?',
    continueWithFacebook: 'Continue with Facebook',
    continueWithGoogle: 'Continue with Google',
    failText: 'Invalid email or password',
    button: {
      signin: 'Sign In with Email'
    },
    successText: 'Sign in successfully',
    social: {
      successText: 'Sign in successfully',
      failText: 'Social sigin in fails, please try again.'
    },
    error: {
      convertAnonymous: 'Sorry, can not convert anonymous order',
      google: 'Google auth error',
      failText: 'Invalid email or password'
    }
  },

  signout: {
    successText: 'Sign out successfully'
  },
  signup: {
    title: 'Sign Up',
    or: 'Or',
    needAccount: 'Need an account ?',
    signup: 'Sign Up',
    signUpWithEmail: 'Sign Up with Email',
    signupConditionText1: 'By creating an account, you agree to our ',
    signupConditionText2: ' and ',
    signupConditionText3: '',
    signupWithFacebook: 'Sign Up with Facebook',
    signupWithGoogle: 'Sign Up with Google',
    referralCode: {
      placeholder: 'Referral Code (optional)',
      invalidText: 'Referral Code Invalid'
    }
  },

  emailSignup: {
    title: 'Sign Up',
    or: 'Or',
    buttonText: 'Sign Up',
    cancelText: 'Cancel',
    nextText: 'Next',
    email: {
      placeholder: 'Email',
      required: 'Email required',
      invalid: 'Email invalid',
      isTaken: 'Email is taken'
    },
    password: {
      placeholder: 'Password',
      required: 'Password required',
      minLength6: 'Password length must be at least 6 characters long'
    },
    confirmPassword: {
      placeholder: 'Confirm Password',
      required: 'Confirm Password required',
      minLength6: 'Confirm Password length must be at least 6 characters long'
    },
    firstName: {
      placeholder: 'First Name',
      required: 'First name required'
    },
    lastName: {
      placeholder: 'Last Name'
    },

    successText: 'Sign up successfully',
    failText: 'Sorry, sign up failed.',
    phoneNumberExists: 'Phone number exists already.',
    error: {
      passwordsNotMatched: 'Password does not match the confirm password.',
      emailExists: 'Email already exists!'
    }
  },

  socialSignup: {
    title: 'Sign Up',
    buttonText: 'Sign Up',
    successText: 'Sign up successfully',
    error: {
      signup: 'Sorry, sign up failed.'
    }
  },

  phoneNumberVerifier: {
    countryCode: 'Country Code',
    placeholder: 'Phone Number',
    button: {
      sendCode: 'Send Code',
      verify: 'Verify'
    },
    sendCodeSuccess: {
      message: 'Please enter 5-digit verification code sent to your phone.'
    },
    sendCodeFail: {
      message: 'Code was not sent. Please try again.'
    },
    verificationCode: {
      placeholder: 'Verification Code'
    }
  },

  forgotPassword: {
    titleText: 'Forgot Password?',
    hintText: 'Please enter your email address to request a password reset.',
    buttonText: 'Send Me Password Reset',
    placeholder: {
      emailAddress: 'EMAIL ADDRESS'
    },
    error: {
      emailInvalid: 'Email Address Invalid',
      resetFailed: 'Password reset failed.'
    },
    success: {
      emailSent: 'Password reset link was sent to your email.'
    }
  },

  resetPassword: {
    titleText: 'Reset Your Password',
    buttonText: 'Change Your Password',
    placeholder: {
      newPasswordText: 'New Password',
      reenterPasswordText: 'Re-enter New Password'
    },

    error: {
      passwordNotMatch: 'Passwords do not match, please retype.',
      passwordLength6: 'Password must be at least 6 characters long.',
      resetFailed: 'Sorry, password reset failed.'
    },
    success: {
      passwordReset: 'Your password has been reset successfully'
    }
  },

  home: {
    line1: 'Order ahead, skip the line,',
    line2: 'and pick-up with Joyaa.',
    placeholder: 'Enter your address',
    getApp: 'Get the app:'
  },

  addressBar: {
    findFood: 'Find Food',
    locationTrackingNotEnabled: 'Location tracking is not enabled!',
    locationTrackingNotAvailable: 'Location tracking is not available!',
    currentLocationText: 'Current Location',
    vancouverText: 'Vancouver',
    calgaryText: 'Calgary',
    edmontonText: 'Edmonton',
    marunouchiText: 'Marunouchi',
    shinjukuText: 'Shinjuku',
    toranomonText: 'Toranomon',
    input: {
      placeholder: 'Enter your address to start'
    },
    geocode: {
      failText: 'Sorry, geocoding failed',
      errorText: 'Address not found'
    },
    currentLocation: {
      tooltip: 'Use Current Location',
      errorText: 'Getting current location is not supported or allowed.'
    }
  },

  restaurants: {
    tooltip: {
      favorite: 'Toggle favorite'
    },
    directionButtonText: 'Direction',
    minsText: 'mins',
    filters: {
      buttonText: 'Filters'
    },
    sorter: {
      buttonText: 'Order By'
    },
    nextOpenTime: {
      closedText: 'Closed',
      opensAtText: 'Opens {dayTime}'
    },
    errors: {
      cuisinesError: 'Error fetching cuisines...',
      currentLocation: 'Sorry, not able to set current location.'
    },
    notFound: "There doesn't seem to be any matched restaurant near you.",
    favorite: {
      clicked: '{restaurantName} is now your favorite!',
      canceled: '{restaurantName} is no longer your favorite!',
      error: 'Sorry, can not change restaurant favorite.'
    }
  },

  filters: {
    button: {
      applyText: 'Apply',
      cancelText: 'Cancel'
    },
    cuisines: {
      titleText: 'Cuisines'
    },
    ratings: {
      titleText: 'Ratings'
    },
    rewardsOnly: {
      titleText: 'Rewards Only',
      titleText2: 'Rewards Only'
    },

    favoritesOnly: {
      titleText: 'Favorites Only',
      titleText2: 'Favorites Only'
    }
  },

  sorter: {
    button: {
      applyText: 'Apply',
      cancelText: 'Cancel'
    },
    list: {
      restaurantName: 'Restaurant Name',
      mostClosest: 'Closest',
      highestRating: 'Highest Rating',
      highestPrice: 'Highest Price',
      lowestPrice: 'Lowest Price'
    }
  },
  restaurant: {
    header: {
      confirmOrderDelete: 'Are you sure you want to delete the order?',
      rating: 'Rating:',
      ratingLink: 'Be the First One to Rate',
      info: {
        direction: 'Direction',
        call: 'Call',
        hours: 'Hours',
        closeButtonText: 'Close'
      },
      estimations: 'Ready in {estimations} mins'
    },
    error: {
      deleteOrder: 'Sorry, can not delete the order.',
      createOrder: 'Sorry, can not create the order.',
      updateDish: 'Sorry, can not update the dish.',
      removeDish: 'Sorry, can not remove the dish.',
      addDish: 'Sorry, can not add the dish.'
    },
    menu: {
      soldOutText: 'Sold Out',
      addButtonText: 'Add',
      addMoreButtonText: 'Add More',
      saveXPointsWithYDolllarText: 'Save {savings} with {points} points'
    },
    cart: {
      subTotalText: 'Subtotal:',
      checkOutButtonText: 'Check Out',
      cartIsEmptyText: 'Cart is Empty',
      cartEmptyReminderText: 'Add a dish to get started.',
      specialRequestText: 'Request:',
      orderExpiredText: 'The order has expired and the page will be updated soon.',
    },
    bottomCart: {
      viewOrderText: 'View Order'
    },
    signInReminder: {
      signInButtonText: 'Sign in',
      notSignInButtonText: 'Continue as Guest',
      signInDescription: 'Sign in  and make fast payment with saved payment card(s).',
      signInDescription1: 'Sign in and earn {subTotal} pts for this order.',
      signInDescription2: ' Make fast payment with the saved payment card(s).',
      nextButtonText: 'Next',
      cancelButtonText: 'Cancel',
      placeholder: 'Enter Your Name (Required)',
      phoneNumberPlaceholder: 'Enter Your Phone Number (Required)'
    },
    isBusyReminder: {
      isBusyText: 'The restaurant may not be able to fulfill your order. We encourage you to try other restaurants or order after the rush.',
      isBusyButtonText: 'Got It',
      isBusyTitleText: 'High Order Volumn'
    },
    isFoodTruckReminder: {
      isFoodTruckText: '{restaurantname} is at {address} today.',
      isFoodTruckText2: '{restaurantname} has multiple locations nearby.</br>This location is at {address} ',
      isFoodTruckText3: '{restaurantname} is at {address} today. Please confirm you want to pick up the order here.',
      isFoodTruckButtonText: 'Got It',
      isFoodTruckButtonText2: 'Confirm',
      isFoodTruckTitleText: 'Pick-up Location'
    }
  },
  saveDish: {
    specialRequestInfo: 'The special request should be less than 200 characters.',
    specialRequest: 'Have a special request?Please enter it here.',
    noEnoughPoints: 'No enough points',
    redeemableText: 'Redeemable on your first purchase',
    signedInUsersOnly: 'Signed in users only',
    addToOrderButtonText: 'Add to Order',
    updateOrderButtonText: 'Update Order',
    removeOrderButtonText: 'Remove Item',
    cancelButtonText: 'Cancel',
    signinLinkText: 'Sign In',
    soldOut: 'Sold Out',
    rewards: {
      error: {
        fetchPoints: 'Sorry, unable to fetch your reward balance.'
      }
    }
  },

  checkBoxGroup: {
    minRequiredText: 'Required',
    chooseUpToX:'Choose up to {maxLimit}',
    chooseAsManyAsYouWouldLike: 'Choose as many as you would like',
    chooseXtoYoptionsfor: 'Choose {minLimit} to {maxLimit} options for {categoryName}',
    chooseAtLeastXoptionsfor: 'Choose at least {minLimit} options for {categoryName}',
    chooseExactlyXoptionsfor: 'Choose exactly {maxLimit} options for {categoryName}'
  },
  radioButtonGroup: {
    requiredText: 'Required'
  },
  checkout: {
    promoErrorText: 'Sorry, can not get promo code.',
    promoIsUsedText: 'Sorry, promo code was used.',
    promoNotAvailableText: 'Sorry, promo code is not avaiable.',
    promoExpiredText: 'Sorry, promo code has expired.',
    promoNotEligibleText:
      'Sorry, no discount because your subtotal is not enough.',
    payWithCreditCardText: 'Pay With Credit Card',
    noItemInOrderText: 'No items in your order',
    backToMenuText: 'Back to Menu',
    error: {
      fetchOrder: 'Sorry, can not fetch order.',

      cancelOrder: 'Sorry, can not cancel the order.',
      updateDish: 'Sorry, can not update the dish.',
      reorder: 'Sorry, can not re-order',
      removeDish: 'Sorry, can not remove the dish'
    },
    dish: {
      specialRequestText: 'Request:'
    },
    summary: {
      subtotalText: 'Subtotal:',
      taxText: 'Tax:',
      tipText: 'Tip:',
      discountText: 'Discount:',
      savingsText: 'Savings:',
      totalText: 'Total:',
      rewardsText: 'Rewards:',
      pointsUsedText: 'Points Used:',
      showDetailsText: 'Show Details',
      hideDetailsText: 'Hide Details',
      pickupTimeText: 'Pickup Time:',
      cancelOrderButtonText: 'Cancel Order',
      confirmCancelOrdereText: 'Are you sure you want to cancel this order?'
    },
    tip: {
      applyButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      addTipText: 'Add Tip',
      tip0: 'No  Tip',
      tip10: '10% Tip',
      tip15: '15% Tip',
      tip20: '20% Tip',
      other: 'Other'
    },
    pickupTime: {
      ASAP: "ASAP",
    },
    promo: {
      applyingText: 'Applying',
      applyButtonText: 'Apply',
      dismissButtonText: 'Dismiss',
      addPromoCodeText: 'Have a promo code?',
      offText: 'Off',
      promoText: 'Promo',
      promoText2: 'Referral reward',
      placeholder: 'Promo Code',
      referralRewardApplied: 'Referral rewards applied!',
      error: {
        notApplied: 'Sorry, the promo code can not apply.',
        fetchReferalReward: 'Sorry, can not fetch referal reward.'
      },
      reminder: {
        cancelButtonText: 'No, Thanks',
        signinLinkText: 'Sign In',
        signupLinkText: 'Sign Up',
        text: 'now to get the promo discount today!'
      }
    },
    creditCard: {
      cancelButtonText: 'Cancel'
    },
    quickPayButton: {
      applePayText: 'Apple Pay',
      googlePayText: 'Google Pay'
    },
    creditCardForm: {
      cardNameText: 'Name on Card',
      cardNumberText: 'Card Number',
      expirationDateText: 'Expiration Date',
      cvcText: 'CVC',
      postalCodeText: 'Postal Code',
      postalCodeTextHint: 'A1A 1A1',
      makePaymentText: 'Make Payment'
    },
    customTip: {
      applyButtonText: 'Apply',
      error: {
        greaterThan0: 'Tip must be greater than zero.',
        numeric: 'Tip amount invalid'
      }
    }
  },

  stripePayButton: {
    addPayCardText: 'Add Pay Card',
    payWithCreditCardText: 'Pay',
    payWithTheCreditCardText: 'Pay With {cardType} {last4}',
    tooltips: {
      selectPaymentCardText: 'Select Payment Card',
      addPaymentCardText: 'Add Payment Card'
    },
    cards: {
      add: {
        linkText: 'Add a New Card',
        cardNumberText: 'Card Number',
        expirationDateText: 'Expiration Date',
        cvcText: 'CVC',
        postalCodeText: 'Postal Code',
        postalCodeTextHint: 'A1A 1A1',
        addCardButtonText: 'Add Card',
        cancelButtonText: 'Cancel',
        error: {
          add: 'Sorry, card is not added.',
          token: 'Sorry, your payment card info is invalid.'
        }
      },
      list: {
        noCardsFoundText: 'No Cards Found',
        tooltips: {
          selectAsDefaultText: 'Select this card',
          removeCardText: 'Remove this card'
        },
        confirmCardDelete: 'Are you sure you want to remove this card?'
      }
    }
  },

  account: {
    payment: {
      titleText: 'Payment Methods'
    },
    update: {
      titleText: 'Update Account',
      successText: 'Your account info is updated.',
      failText: 'Sorry, your account can not be updated.',
      placeholder: {
        picture: 'Picture',
        changePicture : 'Change Picture',
        countryCode: 'Country Code',
        phoneNumber: 'Phone Number',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        referralCode: 'Referral Code'
      },
      saveButtonText: 'Save',
      cancelButtonText: 'Cancel',
      editButtonText: 'Change',
      firstName: {
        required: 'First name required!'
      }
    },
    orders: {
      titleText: 'Orders',
      pastButtonText: 'Past',
      currentButtonText: 'Current',
      viewReceiptButtonText: 'View Receipt',
      pickupText: 'Picked up on {pickupDate}',
      rateOrderButtonText: 'Rate Order',
      reorderButtonText: 'Re-order',
      noOrderFoundText: 'No order is found',
      success: {
        emailSent: 'Email  sent successfully.'
      },
      error: {
        fetchOrders: 'Sorry, can not fetch orders.',
        fetchOrder: 'Sorry, can not fetch the order.',
        emailSent: 'Sorry, email not sent successfully.',
        rating: 'Sorry, can not rate this order.'
      },
      rating: {
        ratingText: 'Rating'
      },
      status: {
        pending: 'Pending',
        accepted: 'Accepted',
        preparing: 'Preparing',
        complete: 'Complete',
        paid: 'Complete',
        rejected: 'Rejected'
      }
    },

    rewards: {
      titleText: 'Rewards',
      pointsText: 'Points',
      summaryText: 'Summary',
      earnText: 'Earn',
      redeemText: 'RedeemText',
      rateRestaurant: 'Rate Restaurante',
      summary: {
        all: 'All',
        earn: 'Earn',
        redeem: 'Redeem'
      },
      redeem: {
        viewOffersText: 'View offers now',
        descriptionText:
          'Redeem at restaurants nearby and convert points for food and drink',
        addressBarPlaceholder: 'Enter your address'
      }
    }
  },
  orderInvite: {
    content: '{hostName} invites you to order food at {restaurantName}',
    button: {
      accept: 'Accept',
      ignore: 'Ignore'
    },
    error: {
      acceptOrderInvite: 'Sorry, unable to accept this invite.',
      ignoreOrderInvite: 'Sorry, unable to ignore this invite.'
    }
  },
  orderInviteChanged: {
    content: '{hostName} changed the pickup time',
    button: {
      accept: 'OK',
    },
    error: {
      acceptOrderInvite: 'Sorry, unable to accept this invite.',
    }
  },
  join: {
    contentText: 'invite you to order food at',
    yesButtonText: 'Yes, for sure!',
    noButtonText: 'No, Thanks',
    okButtonText: 'Ok',
    error: {
      tokenExpired: 'Sorry, join token is invalid or expired.',
      createOrder: 'Sorry, error when joining the host order.'
    }
  },

  friends: {
    titleText: 'Friends',
    newTag: 'New Tag',
    header: {
      friendRequests: 'Friend Requests',
      findFriends: 'Find Friends'
    },
    tooltip: {
      addTag: 'Add new tag'
    },
    button: {
      search: 'Search'
    },
    placeholder: {
      search: 'Search name or tag for your friends'
    },

    tabs: {
      friends: 'Friends',
      add: 'Add',
      pending: 'Pending'
    },
    addFriend: {
      labelText: 'Invite friend',
      inviteesTitle: 'Friends invited lately',
      placeholder: {
        phoneOrEmail: 'Phone or email'
      },
      phoneOrEmailNotFound:
        'Your friend is not found at Joyaa. Do you want to ask her or him to join Joyaa?',
      success: {
        friendRequestSent: 'Friend request is sent successfully.'
      },
      error: {
        friendRequestSent: 'Sorry, friend request can not be sent.',
        fetchPendingInvites: 'Sorry, can not fetch pending invites.'
      }
    },
    referFriend: {
      titleText: 'Ask Friends to Join',
      descriptionText:
        `Invite your friends to Joyaa and both of you will receive 2000 points!`,
      referralCodeText: 'Referral Code',
      message:
        `You should order your next meal through the Joyaa app!\n` +
        `Order ahead instead of waiting in line for lunch.\n` +
        `Sign up with my code '{referralCode}' and get 2000 points. `,
      emailSubjectText: ':firstName invite you join Joyaa!'
    },
    error: {
      fetchFriends: 'Sorry, not able to fetch friends!',
      removeTag: 'Sorry, tag can not be removed.',
      unfriend: 'Sorry, unfriend is not success.'
    }
  },

  friendRequests: {
    button: {
      accept: 'Accept',
      acceptNow: 'Accept Now',
      ignore: 'Ignore'
    },
    error: {
      fetchRequests: 'Sorry, can not get friend requests!',
      accept: 'Sorry, friend request can not be accepted.',
      reject: 'Sorry, friend request can not be rejected.'
    }
  },

  findFriends: {
    title: 'Find Friends',
    button: {
      connect: 'Connect',
      remove: 'Remove',
      cancel: 'Cancel',
      requestSent: 'Request Sent',
      requestRejected: 'Request Rejected',
      friend: 'Friend'
    },

    placeholder: {
      phoneOrEmail: 'Your Friend Phone or Email'
    },

    error: {
      fetchInviteList: 'Sorry, not able to fetch invite list',
      cancelInvite: 'Sorry, not able to cancel your invite.',
      sendRequest: 'Sorry, can not send friend request.',
      findFriend: 'Sorry, unable to find the friend.',
      invalidInput: 'Invalid phone or email!',
      notFound: 'Your friend is not found in our system!'
    }
  },

  friendDetails: {
    name: 'Name',
    email: 'Email',
    displayName: 'Display Name:',
    tags: 'Tags:',
    confirm: {
      unfriend: 'Are you sure you want to unfriend {friend}?'
    },
    error: {
      setDisplayName: 'Sorry, display name can not be changed!',
      removeTag: 'Sorry, tag can not be removed!'
    }
  },

  refer: {
    copied: 'Referral code is copied!',
    titleText: 'Refer Friends',
    descriptionText:
      `Invite your friends to Joyaa and both of you will receive 2000 points!`,
    referralCodeText: 'Referral Code',
    message:
      `You should order your next meal through the Joyaa app! Order ahead instead of ` +
      `waiting in line for lunch. Sign up with my code ':referralCode' ` +
      `get $2 off your first order.`,
    emailSubjectText: ':firstName invite you join Joyaa!'
  },

  inviteLink: {
    pickupForFriends: 'Pick up for friends?',
    error: {
      serverError: 'Sorry, invite link is not created!',
      signInFirst: 'Please sign in first.'
    },
    modal: {
      title: 'Invite friends and earn reward points!',
      menu: {
        friends: 'Friends',
        shareLink: 'Share Link'
      }
    },
    sendLink: {
      title: 'Share the Link',
      button: 'Copy',
      copied: 'Invite link is copied.'
    },

    sendInvites: {
      title: {
        invites: 'Friends to Invite',
        invited: 'Friends Invited'
      },
      placeholder: {
        search: 'Enter friend name or tag'
      },
      button: 'Invite',
      success: {
        sendOrderInvites: 'Sent order invites successfully!'
      },
      error: {
        fetchOrderInvites: 'Sorry, can not fetch order invites.',
        sendOrderInvites: 'Sorry, unable to send order invites.',
        fetchFriends: 'Sorry, can not fetch friends.'
      }
    }
  },
  joinLink: {
    error: {
      createLink: 'Sorry, join order link can not be created!'
    }
  },
  orderStatus: {
    title: {
      normalOrder: 'Order Status',
      groupOrder: 'Pick up for friends'
    },
    confirm: {
      cancelOrder: 'Are you sure you want to cancel this order?',
      hostOrderCanceled:
        'Host order is canceled. Do you want to cancel your order or continue as a solo order',
      yesButtonText: 'Cancel Order',
      noButtonText: 'Continue as Solo'
    },

    button: {
      acceptOrder: 'Accept Order',
      rejectOrder: 'Reject Order',
      cancelOrder: 'Cancel Order',
      emailReceipt: 'Email Receipt'
    },
    success: {
      acceptOrder: 'Restaurant accepts the order!',
      rejectOrder: 'Restaurant rejects the order!',
      cancelOrder: 'Order was canceled successfully.',
      emailReceipt: 'Receipt was sent to you'
    },
    error: {
      fetchOrder: 'Sorry, can not get order status.',
      acceptOrderError: 'Sorry, this order is not accepted!',
      rejectOrderError: 'Sorry, this order is not rejected!',
      cancelOrder: 'Sorry,  this order can not be canceled.',
      emailReceipt: 'Sorry, unable to send the email receipt.'
    },
    step: {
      waitForRestaurantConfirm:
        'Order sent. Waiting for restaurant confirmation...',
      orderRejected: 'Sorry, your order is rejected.',
      foodPrepared: 'Your food is being prepared...',
      pickup:
        'Your food is ready. Please head to the restaurant pick-up counter with code ({shortCode}).'
    },
    guestStep: {
      waitForHost: 'Order sent. Waiting for restaurant to accept the order.',
      foodPrepared: 'Your food is being prepared...',
      pickup: 'Your food is ready. {host} will bring it to you.'
    }
  },
  verifyEmail: {
    spinner: 'Verify Email ... ',
    error: {
      invalidCodeOrEmail: 'Sorry, invalid code or email.'
    },
    success: {
      verified: 'Email is verified. Thanks!'
    }
  },

  info: {
    titleText: 'Info'
  },

  feedback: {
    placeholder: 'How can we make your life easier?',
    button: {
      send: 'Send',
      cancel: 'Cancel'
    },
    success: 'Thank you, we received your feedback.',
    error: 'Sorry, unable to receive your feedback.'
  },
  PRICE: '{price, number, currency}' 
};
